export default __webpack_public_path__ + "static/media/profile-photo-500.8fb1feb8.webp";